import api from './api';
import { TypeStock, StockItem } from '../types';

const stockService = {
  getAll: (type?: TypeStock) =>
    api.get<StockItem[]>('/api/stock', { params: type ? { type } : undefined }).then((r) => r.data),

  getById: (id: number) =>
    api.get<StockItem>(`/api/stock/${id}`).then((r) => r.data),

  create: (data: Omit<StockItem, 'id'>) =>
    api.post<StockItem>('/api/stock', data).then((r) => r.data),

  update: (id: number, data: Partial<Omit<StockItem, 'id'>>) =>
    api.put<StockItem>(`/api/stock/${id}`, data).then((r) => r.data),

  delete: (id: number) =>
    api.delete(`/api/stock/${id}`).then((r) => r.data),
};

export default stockService;
